import PropTypes from 'prop-types'
import fastenLogo from '../assets/icons/fasten-logo-green.svg'
import HelpTooltip from './HelpTooltip'
import { Badge } from './ui/badge'
import { Button } from './ui/button'
import { formatDollarAmountWithCents, formatDollarAmountWhole, formatPoints } from '../utils/string-format-utils'

export default function RewardsBreakdown({ categories }) {
  const totalPoints = categories.reduce((sum, cat) => sum + (cat.dollarAmount * cat.pointMultiplier), 0);
  const redemptionValue = totalPoints / 100;

  return (
    <div className="bg-white rounded-[12px] px-3 pt-6 pb-4 border border-gray-200 w-full h-fit">
        <div className="mb-5 mx-3">
          <h3 className="text-black text-lg font-semibold leading-8">
            Earn Rewards with{' '}
            <img src={fastenLogo} alt="Fasten" className="w-20 h-5 inline-block align-middle ml-1" />
          </h3>
        </div>
      <div className="border-t border-gray-200 my-5 mx-3"></div>
      
      <div className="space-y-4">
        {categories.map((category, index) => (
          <div key={index} className="mx-3">
            <div className="flex justify-between items-center h-full">
              <div className="flex items-center">
                <span className="text-gray-400 text-sm font-medium">{category.name}</span>
                {category.description && <HelpTooltip content={category.description} />}
              </div>
              <span className="text-black text-lg font-semibold">${formatDollarAmountWhole(category.dollarAmount)}</span>
            </div>
            {category.pointMultiplier > 0 && (
              <div className="flex justify-between items-center">
                <div className="flex items-center gap-1">
                  <span className="text-gray-400 text-xs font-normal">
                    {category.pointName || `${category.pointMultiplier}x points`}
                  </span>
                  {category.pointDescription && <HelpTooltip content={category.pointDescription} />}
                </div>
                <Badge>{formatPoints(category.dollarAmount * category.pointMultiplier)} pts</Badge>
              </div>
            )}
          </div>
        ))}

        <div className="border-t border-gray-200 my-5 mx-3"></div>
 
        <div>
          <div className="flex justify-between items-center mb-2 mx-3">
            <span className="text-sm font-semibold text-black">Total points</span>
            <span className="text-lg font-semibold text-black">{formatPoints(totalPoints)} pts</span>
          </div>
          
          <div 
            className="flex justify-between items-center px-3 py-1 rounded-md"
            style={{
              borderRadius: '6px',
              background: 'var(--Rally-Gold---Disabled, #FFE4B2)',
            }}
          >
            <span className="text-sm font-semibold text-black pr-4">Points redemption value</span>
            <span className="text-2xl font-semibold text-black mt-1">${formatDollarAmountWithCents(redemptionValue)}</span>
          </div>
          
          <div className="mx-3">
            <a 
              href="https://app.fasten.cc/sign-up"
              target="_blank"
              rel="noopener noreferrer"
              className="block mt-4"
            >
              <Button 
                className="w-full h-11 px-4 pt-2.5 pb-2 rounded-xl border border-gray-300 bg-white hover:bg-gray-50 focus:bg-gray-100 active:bg-gray-100 text-gray-700 text-sm font-medium leading-5 shadow-xs transition-colors"
                style={{
                  boxShadow: '0 1px 2px 0 rgba(16, 24, 40, 0.05)',
                  color: 'var(--Gray-700, #344054)'
                }}
              >
                Learn more on fasten.cc
              </Button>
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

RewardsBreakdown.propTypes = {
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      dollarAmount: PropTypes.number.isRequired,
      pointMultiplier: PropTypes.number.isRequired,
      description: PropTypes.string,
    })
  ).isRequired,
}
